export const API_SERVER = "https://api.namvotes.site";
